import React from 'react';
import withStyles from "../wrappers/withStyles";

function Referrals({ color }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
      <path
        fill={color}
        fillRule="nonzero"
        stroke="none"
        strokeWidth="1"
        d="M73.492 11.356c-4.187-4.186-9.73-6.474-15.644-6.474-5.916 0-11.475 2.305-15.661 6.491L40 13.56l-2.22-2.22c-4.187-4.186-9.763-6.508-15.678-6.508a21.977 21.977 0 00-15.627 6.474C2.288 15.492-.017 21.051 0 26.966 0 32.882 2.322 38.424 6.51 42.61l31.83 31.83c.44.442 1.034.679 1.61.679.577 0 1.17-.22 1.61-.661l31.899-31.78c4.186-4.186 6.491-9.746 6.491-15.66.017-5.916-2.27-11.475-6.457-15.662zm-3.255 28.085L39.95 69.61 9.73 39.39c-3.322-3.322-5.153-7.729-5.153-12.424 0-4.695 1.814-9.101 5.136-12.407a17.425 17.425 0 0112.39-5.135c4.695 0 9.119 1.83 12.44 5.152l3.831 3.83a2.281 2.281 0 003.237 0l3.797-3.796A17.478 17.478 0 0157.83 9.458c4.678 0 9.084 1.83 12.406 5.135 3.322 3.322 5.136 7.73 5.136 12.424.017 4.695-1.814 9.102-5.136 12.424z"
        transform="translate(10 10)"
      />
    </svg>
  );
}

Referrals.defaultProps = {
  color: 'white',
};

export default withStyles(Referrals);
